export default __webpack_public_path__ + "static/project-slide-6-1248-765-8a6160177814a920b87a380b10fd8a8c.webp";